var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner"}},[_c('parallax',{attrs:{"fixed":true,"sectionClass":'parallax-container'}},[_c('div',{staticClass:"banner__img",style:({ backgroundImage: 'url(' + _vm.bannerUrl + ')' })})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }